export const DELIVERY_MODE_OPTIONS = [
    { value: 1, label: 'On Campus Only' },
    { value: 2, label: 'Online Only' },
    { value: 3, label: 'On Campus & Online' },
];

// Only mode 3 is user-selectable. Modes 1 and 2 derive the online nature.
export const ON_CAMPUS_ONLINE_NATURE_OPTIONS = [
    { value: 1, label: '100% Online' },
    { value: 2, label: 'Blended' },
];
